/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Button, InputText, Text } from '@myinterview/component-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IUserBasicDetails } from '../interfaces';
import { validation } from '../utils/validation';

interface IPopupForm {
  overQuotaFormButtonText: string;
  onSendApplicationOverQuota: (userDetails:IUserBasicDetails) => void;
}

export const PopupForm:React.FC<IPopupForm> = ({
  overQuotaFormButtonText,
  onSendApplicationOverQuota,
}) => {
  const [formDetails, setFormDetails] = useState<IUserBasicDetails>({ firstName: '', lastName: '', email: '' });
  const [areValidFields, setAreValidFields] = useState({ firstName: false, lastName: false, email: false });
  const { t } = useTranslation();

  const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    try {
      await validation[name].validate(value);
      setAreValidFields((prev) => ({ ...prev, [name]: true }));
    } catch {
      setAreValidFields((prev) => ({ ...prev, [name]: false }));
    }
    setFormDetails((prev) => ({ ...prev, [name]: value }));
  };

  const isButtonDisabled = !Object.values(areValidFields).every(Boolean) || ['Thanks!', 'Sending...'].includes(overQuotaFormButtonText);

  const handleSubmit = () => !isButtonDisabled && onSendApplicationOverQuota(formDetails);

  return (
    <div className="popup-form-wrapper">
      <div className="popup-message">
        <Text className="popup-message__greeting" size="H3-Semibold">{t('hi')}</Text>
        <Text className="popup-message__message" size="M-Regular">{t('inactiveJob.description')}</Text>
      </div>

      <div className="popup-form dynamic-direction">
        <div className="popup-form__username">
          <div className="popup-form__firstname">
            <Text size="S-Regular">{t('form.firstname')}</Text>
            <InputText name="firstName" placeholder={t('form.firstname')} onChange={handleChange} />
          </div>
          <div className="popup-form__lastname">
            <Text size="S-Regular">{t('form.lastname')}</Text>
            <InputText name="lastName" placeholder={t('form.lastname')} onChange={handleChange} />
          </div>
        </div>
        <div className="popup-form__email">
          <Text size="S-Regular">{t('form.email')}</Text>
          <InputText name="email" type="email" placeholder={t('form.email')} onChange={handleChange} />
        </div>
        <Button onClick={handleSubmit} disabled={isButtonDisabled}><Text size="L-Regular" color="white">{overQuotaFormButtonText}</Text></Button>
      </div>
    </div>
  );
};
